import { RootState } from "redux/rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.mentalCheckTypeInfo.loading;
export const selectErrorMessage = (state: RootState) =>
  state.mentalCheckTypeInfo.error;
export const mentalCheckTypeInfoDataResponse = (state: RootState) =>
  state.mentalCheckTypeInfo.mentalCheckTypeInfoResponse;
